import instance from "services";

export default async function GetRefreshToken(data: any) {
    const response = await instance.post('/v1/identity/connect/refresh-token', {...data})
    return response.data
}
